import { Calendar, CalendarCheck, Car, CircleDot, Coins, FileSignature, FileText, Fuel, Gauge, History, LayoutDashboard, MapPin, Receipt, Settings, Ticket, Users, Wrench, type LucideIcon } from 'lucide-react';
import { t } from '../../i18n';

export interface NavItem {
  name: string;
  href: string;
  icon: LucideIcon;
  end?: boolean;
  /** Feature that is announced but not working yet (shown with a "Coming soon" badge) */
  upcoming?: boolean;
}

/** Main sections, shared by the sidebar and the tile view. */
export const NAVIGATION = (): NavItem[] => [
  { name: t('Prehľad'), href: '/', icon: LayoutDashboard, end: true },
  { name: t('Vozidlá'), href: '/cars', icon: Car },
  { name: t('Vodiči'), href: '/drivers', icon: Users },
  { name: t('Rezervácie'), href: '/reservations', icon: CalendarCheck },
  { name: t('Pridelenie'), href: '/assignments', icon: Calendar },
  { name: t('Zmluvy'), href: '/contracts', icon: FileSignature },
  { name: t('Plán údržby'), href: '/maintenance', icon: Gauge },
  { name: t('Servisy'), href: '/services', icon: Wrench },
  { name: t('Pneumatiky'), href: '/tires', icon: CircleDot },
  { name: t('Diaľničné známky'), href: '/vignettes', icon: Ticket },
  { name: t('Pokuty'), href: '/fines', icon: Receipt },
  { name: t('Palivo'), href: '/fuel', icon: Fuel },
  { name: t('Náklady'), href: '/expenses', icon: Coins },
  { name: t('Dokumenty'), href: '/documents', icon: FileText },
  { name: t('GPS jazdy'), href: '/gps', icon: MapPin },
];

export const ADMIN_NAVIGATION = (): NavItem[] => [
  { name: t('Audit log'), href: '/audit', icon: History },
  { name: t('Nastavenia'), href: '/settings', icon: Settings },
];
